import { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { BaseToast } from './BaseToast.tsx';

import {
  notificationContainerStyles,
  notificationIconContainerStyle,
  notificationsHeadlineStyle,
  notificationSubtextStyle,
  notificationTextContainerStyle
} from '@/components/Toast/components/styles';
import CloseButton from '@/components/Toast/components/CloseButton.tsx';
import DoubleHeartsShape from '@/components/common/svg/shapes/DoubleHeartsShape.tsx';
import CheckShape from '@/components/common/svg/shapes/CheckShape.tsx';

const PERCENT_TOAST_FIRST_SHOW = 60;
const PERCENT_TOAST_SECOND_SHOW = 30;

export const LikesLimitToast = ({
  totalLikes,
  likesLeft
}: {
  totalLikes: number;
  likesLeft: number;
}) => {
  const { t } = useTranslation();

  if (!totalLikes) return null;

  const likesLeftPercent = (likesLeft / totalLikes) * 100;

  let headerKey: string | null = null;
  let descriptionKey: string | null = null;

  if (Math.round(likesLeftPercent) === PERCENT_TOAST_FIRST_SHOW) {
    headerKey = 'likes_limit_toast.header_60';
    descriptionKey = 'likes_limit_toast.description_60';
  } else if (Math.round(likesLeftPercent) === PERCENT_TOAST_SECOND_SHOW) {
    headerKey = 'likes_limit_toast.header_30';
    descriptionKey = 'likes_limit_toast.description_30';
  } else {
    return null;
  }

  const progressPercentage = ((totalLikes - likesLeft) / totalLikes) * 100;

  return (
    <BaseToast toastKey="likes-limit-popup" role="notification">
      <div style={notificationContainerStyles}>
        <div
          style={
            { ...iconContainerStyle, position: 'relative' } as CSSProperties
          }
        >
          <DoubleHeartsShape width={40} height={40} fillColor="#fff" />

          <div
            style={{
              position: 'absolute',
              bottom: '-3px',
              right: '-3px',
              width: '15px',
              height: '15px',
              backgroundColor: '#F85A89',
              border: '3px solid #ffffff',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
              zIndex: 1
            }}
          >
            <CheckShape
              width={12}
              height={12}
              strokeColor="#ffffff"
              strokeWidth={3}
              style={{ flexShrink: 0 }}
            />
          </div>
        </div>

        <div style={notificationTextContainerStyle}>
          <div style={notificationsHeadlineStyle}>
            {t(headerKey, { likesLeft })}
          </div>
          <p style={notificationSubtextStyle}>
            {t(descriptionKey, { likesLeft })}
          </p>
          <div style={progressBarContainerStyle}>
            <div
              style={{ ...progressBarStyle, width: `${progressPercentage}%` }}
            />
          </div>
        </div>
        <div style={notificationIconContainerStyle}>
          <CloseButton handleClose={() => toast.dismiss()} />
        </div>
      </div>
    </BaseToast>
  );
};

const iconContainerStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '60px',
  height: '60px',
  backgroundColor: '#F85A89',
  borderRadius: '50%',
  flexShrink: 0
};

const progressBarContainerStyle: CSSProperties = {
  width: '100%',
  height: '4px',
  backgroundColor: '#E5E7EB',
  borderRadius: '3px',
  marginTop: '8px',
  overflow: 'hidden'
};

const progressBarStyle: CSSProperties = {
  height: '100%',
  backgroundColor: '#F85A89',
  borderRadius: '3px',
  transition: 'width 0.3s ease-in-out'
};
